import cookie, {CookieAttributes} from "js-cookie"

export const setCookie = (
  name: string,
  value: string,
  options?: CookieAttributes
) => {
  cookie.set(name, value, options)
}

export const getCookie = (name: string) => {
  return cookie.get(name)
}

export const removeCookie = (name: string) => {
  cookie.remove(name)
}

export const getNotificationAccess: () =>
  | "denied"
  | "dismissed"
  | "granted"
  | undefined = () => {
  return getCookie("notification_access") as "denied" | "dismissed" | undefined
}

export const getSelectedCity: () => number | undefined = () => {
  const selectedCity = getCookie("selectedCity")
  return selectedCity ? parseInt(selectedCity) : undefined
}
